import type { SxProps, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { CHECKBOX_HIDDEN_ROW_CLASS } from './GeneratikTable.constants';

export const predefinedFiltersWrapperSx: SxProps<Theme> = {
  mb: 2,
};

export const getTablePaperSx = (
  fillHeight: boolean,
  tableHeight: number | string | undefined,
): SxProps<Theme> => ({
  height: fillHeight ? undefined : tableHeight,
});

interface TableContainerSxParams {
  fillHeight: boolean;
  noTopPadding: boolean | undefined;
  noPadding: boolean | undefined;
  height: number | string | 'fill' | 'auto' | undefined;
}

export const getTableContainerSx = ({
  fillHeight,
  noTopPadding,
  noPadding,
  height,
}: TableContainerSxParams): SxProps<Theme> | undefined => {
  if (fillHeight) {
    if (noPadding) return { padding: 0 };
    return { padding: noTopPadding ? '8px 1rem 1rem' : '1rem' };
  }
  if (height === 'auto') return undefined;
  return { height };
};

interface DefaultDataGridSxParams {
  fillHeight: boolean;
  height: number | string | 'fill' | 'auto' | undefined;
  radioSelection: boolean | undefined;
  hasRowGrouping: boolean;
  consumerSx: object | undefined;
}

export const buildDefaultDataGridSx = ({
  fillHeight,
  height,
  radioSelection,
  hasRowGrouping,
  consumerSx,
}: DefaultDataGridSxParams): SxProps<Theme> => ({
  flex: fillHeight ? 1 : undefined,
  minHeight: fillHeight ? 0 : undefined,
  ...(hasRowGrouping ? { '--DataGrid-cellOffsetMultiplier': 6 } : undefined),
  '& .MuiDataGrid-virtualScroller': {
    overflowX: 'auto',
    overflowY: height === 'auto' ? 'visible' : 'auto',
    scrollbarGutter: 'stable',
    ...(height !== 'auto' ? { overscrollBehavior: 'none' } : { overscrollBehaviorX: 'none' }),
  },
  [`& .${CHECKBOX_HIDDEN_ROW_CLASS} .MuiDataGrid-cellCheckbox > *`]: { visibility: 'hidden' },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    position: 'relative',
  },
  ...(radioSelection && {
    '& .MuiDataGrid-columnHeaderCheckbox': {
      pointerEvents: 'none',
      '& *': { visibility: 'hidden' },
    },
    '& .GeneratikTable-groupRow .MuiDataGrid-cellCheckbox': {
      pointerEvents: 'none',
      '& *': { visibility: 'hidden' },
    },
  }),
  ...consumerSx,
});

export const getFooterRowSx =
  (isListView: boolean) =>
  (theme: Theme): SystemStyleObject<Theme> =>
    isListView
      ? {
          borderRadius: '14px',
          boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
          backgroundColor: theme.palette.background.paper,
          overflow: 'hidden',
        }
      : {};
